<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('kits.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <btn-primary @click="to_create_new" :label="'kits.new'" :icon="'add_box'" v-permission:any="'kit.create|kit_detail.create'"></btn-primary>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 20, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                                <h3 class="text-uppercase">
                                    {{ $t('kits.modal.delete') }}
                                </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('kits.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('kits.no') }}</v-btn>
                            <v-btn color="error" @click="deleteLocation">
                                {{ $t('kits.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import { kitsIndexUseCase } from '../../kits/application/use_cases/kits_index_use_case'
import { HttpKitRepository } from '../../kits/infrastructure/kit_repository'

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('kits.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('kits.description'), align: "center", value: 'description', class: 'text-uppercase' },
                { text: this.$t('kits.customer'), align: "center", value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('kits.products_included'), align: "center", value: 'products_count', class: 'text-uppercase' },
                { text: this.$t('kits.actions'), align: "center", value: 'actions', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            idCustom_agent: '',
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false}
        }
    },
    mounted(){
        this.$store.state.module = "headers.kits";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];

                const res = await kitsIndexUseCase(this.props.meta.page, this.props.meta.per_page, this.props.search, this.props.sort_by, HttpKitRepository);
                this.props.items = res.data;
                this.props.meta = res.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        askDelete(custom_agent){
            this.modalDelete = true;
            this.idCategory = custom_agent.id;
        },
        deleteLocation(){
            console.log(this.idCustom_agent);
        },
        update(custom_agent){
            console.log(custom_agent);
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
        to_create_new() {
            this.$router.push("/kits/create");
        }
    },
    watch: {
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.index();
            }, 800);
        }
    }
}
</script>

<style>

</style>